import React, { useState } from "react"
import MetaTags from "react-meta-tags"
import {
  Col,
  Container,
  Row,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap"

import ServiceStructure from "../../components/Services/structure/ServiceStructure"

const EnvironmentalAudit = () => {
  const [menu, setMenu] = useState(false)
  const toggle = () => {
    setMenu(!menu)
  }
  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Environmental Audit | REMA</title>
        </MetaTags>
        <Container fluid>
          <div className="page-title-box">
            <Row className="align-items-center">
              <Col md={12}>
                <h6 className="page-title">
                  Request for Environmental Audit
                </h6>

                <ServiceStructure
                  disablePayableFee={true}
                  disableLicenseValidity={true}
                  disableProcessingTime={true}
                  detailsType="environmental-audit"
                  url="environmental-audit-apply"
                  serviceType="Request for Environmental Audit"
                  department="Division of Environmental Compliance and Enforcement (DECE)"
                />
              </Col>
            </Row>
          </div>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default EnvironmentalAudit
